import React, { useState, useEffect, useRef } from 'react';
// Import d3 directly
import * as d3 from 'd3';
import { useSelector } from "react-redux";
import JBrowseService from '../services/jbrowse.service';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

const CircosPlot = ( props ) => {
  console.log('props: ', props );
  let { 
    isOpen, 
    setIsOpen,
    assembly,
    setBlastModalIsOpen,
  } = props;
  const [chromosomes, setChromosomes] = useState([]);
  const containerRef = useRef(null);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [selectedOption, setSelectedOption] = useState('');
  const [filteredTracks, setFilteredTracks] = useState([]);
  const [originalTracks, setOriginalTracks ] = useState([]);
  let [ LINK01, setLINK01 ] = useState(null);

  const filterOptions = [
    { label: 'E-value = 0', value: '0' },
    { label: '< 1e-50', value: '<1e-50' },
    { label: '< 1e-40', value: '<1e-40' },
    { label: '< 1e-30', value: '<1e-30' },
    { label: '< 1e-20', value: '<1e-20' },
    { label: '< 1e-10', value: '<1e-10' },
    { label: 'All', value: 'All' },
  ];

  const greenColorArray = [
    '#f0fff4', // Very light green
    '#e6ffe8',
    '#d9ffdb',
    '#ccffcf',
    '#bfffbe',
    '#b3ffb3',
    '#a6ffa6',
    '#99ff99',
    '#8cff8c',
    '#80ff80',
    '#73ff73',
    '#66ff66', // Bright green
    '#59e659',
    '#4dcc4d',
    '#40b340',
    '#339933',
    '#268026', // Medium green
    '#1a661a',
    '#0d4d0d',
    '#003300', // Dark green
    '#002e00',
    '#002800',
    '#002200',
    '#001d00',
    '#001700',
    '#001200',
    '#000c00',
    '#000700', 
    '#000300', 
    '#000000'  // Almost black-green
];

  // Get Colors for Legend
  const getColorForChromosome = (index) => greenColorArray[index];

  // Fetch chromosome data from the database
  useEffect(() => {
    if( currentUser && assembly ) {
      const obj = {
        company: currentUser.DirectoryName,
        assembly: assembly.endsWith('.fa') ? assembly : `${assembly}.fa`
      };
      
      console.log("chromosome obj: ", obj );
      // Get Chromosomes
      JBrowseService.getChromosomesFromDatabase(obj).then(
        (response) => {
          console.log("chromeasome response: ", response );
          const arr = response.map(item => [item.Chromosome, item.Length]);
          setChromosomes(arr);
        },
        (error) => {
          console.log("error:", error);
        }
      );
      // Get JSON Data
      let json = { user: currentUser.email, };
      JBrowseService.getCircosJson(json).then(
        (response) => {
          console.log("circos response: ", response );
          setLINK01( response.result );
          setFilteredTracks( response.result[2] );
          setOriginalTracks( response.result[2] );
          // Sample link data
          // var LINK01 = [
          //   "LINK01",
          //   {
          //     "LinkRadius": 140,
          //     "LinkFillColor": "#F26223",
          //     "LinkWidth": 3,
          //     "displayLinkAxis": true,
          //     "LinkAxisColor": "#B8B8B8",
          //     "LinkAxisWidth": 0.5,
          //     "LinkAxisPad": 3,
          //     "displayLinkLabel": true,
          //     "LinkLabelColor": "red",
          //     "LinkLabelSize": 13,
          //     "LinkLabelPad": 8
          //   },
          //   [
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrA01_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 1,
          //       "g1end": 5047,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrA01_contigs_placed_v81",
          //       "g2start": 22710,
          //       "g2end": 27756,
          //       "g2name": "chrA01_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrC01_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 18,
          //       "g1end": 3668,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrC01_contigs_placed_v81",
          //       "g2start": 410743,
          //       "g2end": 414478,
          //       "g2name": "chrC01_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrC01_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 3671,
          //       "g1end": 5047,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrC01_contigs_placed_v81",
          //       "g2start": 415000,
          //       "g2end": 416370,
          //       "g2name": "chrC01_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrA08_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 2269,
          //       "g1end": 2603,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrA08_contigs_placed_v81",
          //       "g2start": 15577134,
          //       "g2end": 15577466,
          //       "g2name": "chrA08_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrA08_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 2614,
          //       "g1end": 2970,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrA08_contigs_placed_v81",
          //       "g2start": 15576669,
          //       "g2end": 15577012,
          //       "g2name": "chrA08_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrA08_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 625,
          //       "g1end": 719,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrA08_contigs_placed_v81",
          //       "g2start": 15579062,
          //       "g2end": 15579158,
          //       "g2name": "chrA08_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrA08_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 433,
          //       "g1end": 478,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrA08_contigs_placed_v81",
          //       "g2start": 15600220,
          //       "g2end": 15600265,
          //       "g2name": "chrA08_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrC03_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 2269,
          //       "g1end": 2554,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrC03_contigs_placed_v81",
          //       "g2start": 59593302,
          //       "g2end": 59593584,
          //       "g2name": "chrC03_contigs_placed_v81"
          //     },
          //     {
          //       "fusion": "chrA01_contigs_placed_v81:22710-27757--chrC03_contigs_placed_v81",
          //       "g1chr": "chrA01_contigs_placed_v81",
          //       "g1start": 433,
          //       "g1end": 478,
          //       "g1name": "chrA01_contigs_placed_v81:22710-27757",
          //       "g2chr": "chrC03_contigs_placed_v81",
          //       "g2start": 59560809,
          //       "g2end": 59560854,
          //       "g2name": "chrC03_contigs_placed_v81"
          //     }
          //   ]
          // ];

          // setLINK01(LINK01);

        },
        (error) => {
          console.log("error:", error);
        }
      );

    }
  }, [currentUser, assembly]);

  // Create the BioCircos instance and attach a d3-based drag to rotate it
  useEffect(() => {
    if (
      typeof window !== 'undefined'
      && window.BioCircos
      && chromosomes.length > 0
      && isOpen 
      && LINK01
      && filteredTracks
    ) {
      console.log("build!");
      // console.log("Link01: ", LINK01 );
      /** Use Filterd Tracks */
      // console.log("filtered tracks: ", filteredTracks );
      LINK01[2] = filteredTracks;

      // Clear any existing SVG
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }

      // Create/Draw the Circos plot
      const BioCircos01 = new window.BioCircos(
        LINK01,
        chromosomes,
        {
          target: "biocircos",
          svgWidth: 900,
          svgHeight: 900,
          innerRadius: 230,
          outerRadius: 380,
          genomeLabelSize: 9, // Slightly reduced from 10
          genomeLabelColor: "#2d2d2d",
          genomeFillColor: greenColorArray,
          chrPad: 0.02,
          genomeTicksDisplay: true,
          genomeTicksLen: 4,
          genomeTicksTextSize: 8,
          zoom: false,
          pan: false,
          tooltip: true,
          disablePan: true,        // Primary pan lock [2][6]
          disableXAxis: true,      // X-axis movement block [2]
          disableYAxis: true,      // Y-axis movement block [2]
          contain: 'inside',       // Prevent boundary overflows [2]
          pinchAndPan: false ,
          genomeLabelDragEvent: false // Prevent label-based dragging [4]
        }
      );
      
      /** Build Circos */
      BioCircos01.draw_genome(BioCircos01.genomeLength);

      const svg = d3.select("#biocircos svg");
      // Create rotation wrapper and preserve BioCircos transforms
      const wrapper = svg.insert("g", ":first-child")
        .attr("class", "rotation-wrapper");
      
      // Move existing BioCircos group into wrapper
      const mainGroup = svg.select("g:not(.rotation-wrapper)");
      wrapper.node().appendChild(mainGroup.node());
      
      const centerX = 450;
      const centerY = 450;
      
      let currentRotation = 0;
      let startAngle = 0;
      
      const getPointerAngle = (event) => {
        // Get coordinates relative to SVG container
        const [x, y] = d3.pointer(event, svg.node());
        const dx = x - centerX;
        const dy = y - centerY;
        return Math.atan2(dy, dx) * (180 / Math.PI);
      };
      
      const dragBehavior = d3.drag()
        .on("start", (event) => {
          startAngle = getPointerAngle(event);
          currentRotation = wrapper.attr("data-rotation") || 0;
        })
        // In the drag handler:
        .on("drag", (event) => {
          const currentAngle = getPointerAngle(event);
          const delta = currentAngle - startAngle;

          // Round rotation to 2 decimal places and use modulo to keep within 360°
          const newRotation = (Number(currentRotation) + delta).toFixed(2) % 360;

          wrapper.attr("transform", `
                        translate(${centerX}, ${centerY})
                        rotate(${newRotation})
                        translate(-${centerX}, -${centerY})
                      `).attr("data-rotation", newRotation);
                            });

      
      // Apply drag to wrapper instead of main group
      wrapper.call(dragBehavior);
      
    }
  }, [chromosomes, isOpen, LINK01, filteredTracks ]);

  const handleFilter = (optionValue) => {
    // Create a copy of the original array using spread operator
    const tracksCopy = [...originalTracks ];
    let newFilteredTracks = [];
  
    if (optionValue === '0') {
      newFilteredTracks = tracksCopy.filter(track => parseFloat(track.eval) === 0);
    } else if (optionValue === '<1e-50') {
      newFilteredTracks = tracksCopy.filter(track => parseFloat(track.eval) < 1e-50);
    } else if (optionValue === '<1e-40') {
      newFilteredTracks = tracksCopy.filter(track => parseFloat(track.eval) < 1e-40);
    } else if (optionValue === '<1e-30') {
      newFilteredTracks = tracksCopy.filter(track => parseFloat(track.eval) < 1e-30);
    } else if (optionValue === '<1e-20') {
      newFilteredTracks = tracksCopy.filter(track => parseFloat(track.eval) < 1e-20);
    } else if (optionValue === '<1e-10') {
      newFilteredTracks = tracksCopy.filter(track => parseFloat(track.eval) < 1e-10);
    } else {
      // Return the copy instead of original array reference
      newFilteredTracks = [...tracksCopy];
    }

    setFilteredTracks(newFilteredTracks);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    handleFilter(value);
  };

  const handleGoBack = () => {
    setIsOpen( false );
    setTimeout( () => {
      setBlastModalIsOpen( true );
    },100);
  }

  return (
    <>
        <Dialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          aria-labelledby="circos-dialog-title"
          PaperProps={{
            style: {
              minWidth: '80vw',  // Viewport-relative width
              maxWidth: '1200px'  // Absolute maximum
            }
          }}
        >
          {/* Sticky Header */}
          <DialogTitle
            id="circos-dialog-title"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #e0e0e0',
              position: 'sticky',
              top: 0,
              zIndex: 10,
              bgcolor: 'background.paper'
            }}
          >
            <Typography variant="h6" component="div">
              Circos Plot
            </Typography>

            <Box>
              <IconButton
                onClick={() => setIsOpen(false)}
                sx={{ mr: 1 }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>

          <Box sx={{ width: 300, marginLeft: '10px', mt: 2, mb: 1 }}>
            <FormControl fullWidth>
              <InputLabel id="filter-label">Filter Tracks</InputLabel>
              <Select
                labelId="filter-label"
                id="filter-select"
                value={selectedOption}
                label="Filter Tracks"
                onChange={handleChange}
              >
                {filterOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                textAlign: 'center',
                color: '#666',
                mt: 1
              }}
            >
              filtered: {filteredTracks?.length || 0} tracks
            </Typography>
          </Box>

        {/* Legend */}
        <Box
          sx={{
            position: 'absolute',
            top: 75,
            right: 0,
            width: 500,
            height: 'auto', // Adjust height to fit the title and content dynamically
            backgroundColor: '#ffffffcc',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: 2, // Increased padding for spacing
            display: 'flex',
            flexDirection: 'column', // Stack title and items vertically
            alignItems: 'flex-start', // Align content to the left
            overflowX: 'auto',
            boxShadow: 2
          }}
        >
          {/* Title */}
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 'bold',
              marginBottom: 1 // Add spacing below the title
            }}
          >
            Chromosome Legend
          </Typography>

          {/* Chromosome Items */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            {chromosomes.map((chrom, i) => {
              const color = getColorForChromosome(i);
              return (
                <Box
                  key={chrom.idChromosome}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: 2,
                    minWidth: 'max-content'
                  }}
                >
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      backgroundColor: color,
                      marginRight: 1,
                      border: '1px solid #000'
                    }}
                  />
                  <Typography variant="caption" noWrap>
                    {i + 1}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

          {/* Circos Plot */}
          <DialogContent
            sx={{
              p: 0,
              overflowY: 'auto',
              display: 'grid', // 1. Use grid for reliable centering
              placeItems: 'center', // 2. Center both axes
              height: '100%', // 3. Ensure full height availability
              maxHeight: 'calc(100vh - 200px)',
            }}
          >
            {/* Plot Container */}
            <Box sx={{
              width: 900,
              height: 900,
              display: 'grid', // 4. Nested grid for redundancy
              placeItems: 'center', // 5. Double-center content
              mx: 'auto',
              p: '10px 0'
            }}>
              <div
                id="biocircos"
                ref={containerRef}
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex', // 6. Third layer of centering
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              />
            </Box>

            <Box
              id="biocircos"
              sx={{ position: 'relative', mt: 2 }}
            >
            </Box>
              <Typography
                variant="caption"
                sx={{
                  position: 'absolute',
                  bottom: 20,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  color: '#666',
                  zIndex: 1000,
                  pointerEvents: 'none'
                }}
              >
                Click and drag to rotate visualization
              </Typography>
          </DialogContent>

          {/* Sticky Footer */}
          <DialogActions
            sx={{
              borderTop: '1px solid #e0e0e0',
              position: 'sticky',
              bottom: 0,
              zIndex: 10,
              bgcolor: 'background.paper',
              justifyContent: 'space-between'
            }}
          >
            <Button
              onClick={handleGoBack}
              variant="contained"
              color="inherit"
              sx={{
                order: -1  // Force left position in flex container
              }}
            >
              Go Back
            </Button>
            <Button
              onClick={() => setIsOpen(false)}
              variant="contained"
              color="inherit"
            >
              Close Viewer
            </Button>
          </DialogActions>
        </Dialog>

    </>
  );
};

export default CircosPlot;
